import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};


const NetworkSecurityAnomalies = () => {

  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "Anomalies",
        data: [420, 300, 900, 500, 450, 200, 180],
        backgroundColor: "#f97316"
      },
      {
        label: "Critical Alerts",
        data: [30, 15, 80, 40, 30, 10, 12],
        backgroundColor: "#fde047"
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false   // 🔹 disable default legend
      }
    },
    scales: {
      x: {
        ticks: { color: "#9ca3af" },
        grid: { color: "rgba(255,255,255,0.05)" }
      },
      y: {
        ticks: { color: "#9ca3af" },
        grid: { color: "rgba(255,255,255,0.05)" }
      }
    }
  };

  return (
    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-bar-chart-line" style={pageIconStyle} ></i>
          </div>
          Network Security Anomalies
        </h5>
      </CardHeader>

      <CardBody>

        {/* Chart */}
        <div style={{ height: "260px" }}>
          <Bar data={data} options={options} />
        </div>

        {/* Minimal Legend */}
        <div
          className="d-flex justify-content-center gap-4 mt-3 mb-3"
          style={{ fontSize: "13px" }}
        >
          <span className="d-flex align-items-center">
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#f97316",
                marginRight: 8
              }}
            ></span>
            Anomalies
          </span>

          <span className="d-flex align-items-center">
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#fde047",
                marginRight: 8
              }}
            ></span>
            Critical Alerts
          </span>
        </div>

        {/* Mini Tiles */}
        <Row className="g-3">

          <Col md={6}>
            <div
              style={{
                border: "1px solid rgba(255,255,255,0.06)",
                borderRadius: "8px",
                padding: "14px"
              }}
            >
              <p className="text-muted mb-1" style={{ fontSize: "13px" }}>
                UNAUTHORIZED EXTERNAL CONNECTIONS
              </p>

              <h4 className="mb-0" style={{ color: "#f97316" }}>
                29
              </h4>
            </div>
          </Col>

          <Col md={6}>
            <div
              style={{
                border: "1px solid rgba(255,255,255,0.06)",
                borderRadius: "8px",
                padding: "14px"
              }}
            >
              <p className="text-muted mb-1" style={{ fontSize: "13px" }}>
                DNS TO MALICIOUS DOMAINS
              </p>

              <h4 className="mb-0" style={{ color: "#f97316" }}>
                03
              </h4>
            </div>
          </Col>

        </Row>

      </CardBody>

    </Card>
  );
};

export default NetworkSecurityAnomalies;